export default __webpack_public_path__ + "static/media/Formulaire-Inscription-Marathon-48h-Halloween-2022.0a1ed802.pdf";